<template>
  <ModalDialog
    ref="dialog"
    title="New Toughening Batch"
    icon="fa-hammer"
    submitTitle="Start Batch"
    sizeClass="modal-xxl"
    :showFooter="true"
    :scrollable="true"
    :submitting="submitting"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <FormUploadDropTarget @filesDropped="$refs.documentUpload.filesDroppedFromTarget($event)">
        <div class="row mb-2">
          <div class="col-5">
            <div class="row no-gutters">
              <div class="col-12">
                <h2>Details</h2>
                <small>&nbsp;</small>
              </div>
            </div>
            <div class="row no-gutters py-1">
              <div class="col-6"><FormStaticLabel>Batch Thickness</FormStaticLabel></div>
              <div class="col-6">
                <FormInputText ref="inputBatchThickness" type="number" placeholder="Batch Thickness" v-model="batch.batchThickness" field="batchThickness" @click="$refs.inputBatchThickness.select()" addon="mm" />
              </div>
            </div>
            <div class="row no-gutters py-1">
              <div class="col-6"><FormStaticLabel>Compliance Type</FormStaticLabel></div>
              <div class="col-6">
                <FormSelect placeholder="Compliance" v-model="batch.complianceType" field="complianceType" :options="ToughenBatchComplianceTypeLookup" />
              </div>
            </div>
            <div class="row no-gutters py-1" v-if="!isComplianceAutomotive">
              <div class="col-6"><FormStaticLabel>Glass Type</FormStaticLabel></div>
              <div class="col-6">
                <FormSelect placeholder="Glass" v-model="batch.glassType" field="glassType" :options="ToughenBatchGlassTypeLookup" />
              </div>
            </div>
            <div class="row no-gutters py-1" v-if="isComplianceAutomotive">
              <div class="col-6"><FormStaticLabel>Luminous Type</FormStaticLabel></div>
              <div class="col-6">
                <FormSelect placeholder="Luminous Transmission" v-model="batch.lumenTransType" field="lumenTransType" :options="ToughenBatchLumenTransTypeLookup" />
              </div>
            </div>
            <div class="row no-gutters py-1">
              <div class="col-6"><FormStaticLabel>Particle Count</FormStaticLabel></div>
              <div class="col-6"><FormInputText ref="inputParticleCount" type="number" placeholder="Particle Count" v-model="batch.batchParticleCount" field="batchParticleCount" @click="$refs.inputParticleCount.select()" /></div>
            </div>
          </div>
          <div class="col-7">
            <div class="row no-gutters">
              <div class="col-12">
                <h2>Thickness Measurements for {{batch.batchThickness | formatDecimal}}mm</h2>
                <small class="font-weight-bold">Plate Micrometre</small>
              </div>
            </div>
            <div class="row no-gutters py-1">
              <div class="col-6 pr-1">
                <FormInputText ref="inputBatchV1" type="number" v-model="batch.batchV1" field="batchV1" prepend="V1" addon="mm" placeholder="V1 Thickness" @click="$refs.inputBatchV1.select()" />
              </div>
              <div class="col-6 pl-1">
                <FormInputText ref="inputBatchV2" type="number" v-model="batch.batchV2" field="batchV2" prepend="V2" addon="mm" placeholder="V2 Thickness" @click="$refs.inputBatchV2.select()" />
              </div>
            </div>
            <div class="row no-gutters py-1">
              <div class="col-6 pr-1">
                <FormInputText ref="inputBatchV3" type="number" v-model="batch.batchV3" field="batchV3" prepend="V3" addon="mm" placeholder="V3 Thickness" @click="$refs.inputBatchV3.select()" />
              </div>
              <div class="col-6 pl-1">
                <FormInputText ref="inputBatchV4" type="number" v-model="batch.batchV4" field="batchV4" prepend="V4" addon="mm" placeholder="V4 Thickness" @click="$refs.inputBatchV4.select()" />
              </div>
            </div>
            <div class="row no-gutters py-1">
              <small>Mean Thickness: 
                <span v-if="plateMeanThickness > 0">{{plateMeanThickness | formatDecimal}}mm</span>
                <span v-if="plateMeanThickness == 0">-</span>
              </small>
            </div>
            <div v-if="isGlassTypePattern">
              <div class="row no-gutters mt-2">
                <div class="col-12">
                  <small class="font-weight-bold">Pattern - Point Micrometre</small>
                </div>
              </div>
              <div class="row no-gutters py-1">
                <div class="col-6 pr-1">
                  <FormInputText ref="inputBatchV5" type="number" v-model="batch.batchV5" field="batchV5" prepend="V5" addon="mm" placeholder="V5 Thickness" @click="$refs.inputBatchV5.select()" />
                </div>
                <div class="col-6 pl-1">
                  <FormInputText ref="inputBatchV6" type="number" v-model="batch.batchV6" field="batchV6" prepend="V6" addon="mm" placeholder="V6 Thickness" @click="$refs.inputBatchV6.select()" />
                </div>
              </div>
              <div class="row no-gutters py-1">
                <div class="col-6 pr-1">
                  <FormInputText ref="inputBatchV7" type="number" v-model="batch.batchV7" field="batchV7" prepend="V7" addon="mm" placeholder="V7 Thickness" @click="$refs.inputBatchV7.select()" />
                </div>
                <div class="col-6 pl-1">
                  <FormInputText ref="inputBatchV8" type="number" v-model="batch.batchV8" field="batchV8" prepend="V8" addon="mm" placeholder="V8 Thickness" @click="$refs.inputBatchV8.select()" />
                </div>
              </div>
              <div class="row no-gutters py-1">
                <small>Mean Thickness: 
                  <span v-if="pointMeanThickness > 0">{{pointMeanThickness | formatDecimal}}mm</span>
                  <span v-if="pointMeanThickness == 0">-</span>
                </small>
              </div>
            </div>
          </div>
        </div>
        <FormHorizontalRule />

        <div class="row mt-2">
          <div class="col-4">
            <div class="row no-gutters">
              <div class="col-12"><h2>Glass Is Within</h2></div>
            </div>
            <div class="row no-gutters mt-2">
              <div class="col-8">Size Tolerance</div>
              <div class="col-4"><FormSwitch booleanMode v-model="batch.sizeTolerance" field="sizeTolerance" /></div>
            </div>
            <div class="row no-gutters mt-3">
              <div class="col-8">Squareness</div>
              <div class="col-4"><FormSwitch booleanMode v-model="batch.squareness" field="squareness" /></div>
            </div>
            <div class="row no-gutters mt-3">
              <div class="col-8">Flatness</div>
              <div class="col-4"><FormSwitch booleanMode v-model="batch.flatness" field="flatness" /></div>
            </div>
          </div>
          <div class="col-4">
            <div class="row no-gutters">
              <div class="col-12"><h2>Australian Standard Marking</h2></div>
            </div>
            <div class="row no-gutters mt-2">
              <div class="col-6">Permanent</div>
              <div class="col-6"><FormOption setting="permanent" v-model="batch.markingType" field="markingType" /></div>
            </div>
            <div class="row no-gutters mt-3">
              <div class="col-6">Label</div>
              <div class="col-6"><FormOption setting="label" v-model="batch.markingType" field="markingType" /></div>
            </div>
          </div>
          <div class="col-4">
            <div class="row no-gutters">
              <div class="col-12"><h2>Compliance</h2></div>
            </div>
            <div class="row no-gutters mt-2">
              <div class="col-6">Photo Taken</div>
              <div class="col-6"><FormSwitch booleanMode v-model="batch.isPhotographTaken" /></div>
            </div>
            <div class="row no-gutters mt-3">
              <div class="col-6">Uploads</div>
              <div class="col-6">
                <FormUpload ref="documentUpload" v-model="batch.uploadFileList" field="uploadFileList" />
              </div>
            </div>
          </div>
        </div>
      </FormUploadDropTarget>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { ToughenBatchComplianceTypes, ToughenBatchComplianceTypeLookup, ToughenBatchGlassTypes, ToughenBatchGlassTypeLookup, ToughenBatchLumenTransTypes, ToughenBatchLumenTransTypeLookup } from '@/store/types'

export default {
  name: 'TougheningBatchDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    productionStageId: Number,
    productionStationId: Number,
    panelThickness: Number
  },
  data() {
    return {
      batch: {
        complianceType: '',
        glassType: '',
        lumenTransType: '',
        batchThickness: 0,
        batchV1: 0,
        batchV2: 0,
        batchV3: 0,
        batchV4: 0,
        batchV5: 0,
        batchV6: 0,
        batchV7: 0,
        batchV8: 0,
        batchParticleCount: 0,
        isPhotographTaken: false,
        uploadFileList: [],
        markingType: '',
        sizeTolerance: false,
        squareness: false,
        flatness: false
      },
      form: {},
      submitting: false
    }
  },
  created() {
    this.ToughenBatchComplianceTypeLookup = ToughenBatchComplianceTypeLookup
    this.ToughenBatchGlassTypeLookup = ToughenBatchGlassTypeLookup
    this.ToughenBatchLumenTransTypeLookup = ToughenBatchLumenTransTypeLookup
  },
  mounted() {
  },
  computed: {
    meanThickness() {
      var meanValue = (parseFloat(this.batch.batchV1) + parseFloat(this.batch.batchV2) + parseFloat(this.batch.batchV3) + parseFloat(this.batch.batchV4)) / 4.0

      if(this.isGlassTypePattern)
        meanValue = (parseFloat(this.batch.batchV1) + parseFloat(this.batch.batchV2) + parseFloat(this.batch.batchV3) + parseFloat(this.batch.batchV4) + parseFloat(this.batch.batchV5) + parseFloat(this.batch.batchV6) + parseFloat(this.batch.batchV7) + parseFloat(this.batch.batchV8)) / 8.0

      if(isNaN(meanValue))
        return 0
      return meanValue
    },
    plateMeanThickness() {
      var meanValue = (parseFloat(this.batch.batchV1) + parseFloat(this.batch.batchV2) + parseFloat(this.batch.batchV3) + parseFloat(this.batch.batchV4)) / 4.0
      if(isNaN(meanValue))
        return 0
      return meanValue
    },
    pointMeanThickness() {
      var meanValue = (parseFloat(this.batch.batchV5) + parseFloat(this.batch.batchV6) + parseFloat(this.batch.batchV7) + parseFloat(this.batch.batchV8)) / 4.0
      if(isNaN(meanValue))
        return 0
      return meanValue
    },
    isComplianceAutomotive() {
      return this.batch.complianceType == ToughenBatchComplianceTypes.automotive
    },
    isGlassTypePattern() {
      return this.batch.complianceType == ToughenBatchComplianceTypes.standard && this.batch.glassType == ToughenBatchGlassTypes.pattern
    }
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false
      // Reset
      // Purposefully don't set values to force the user to enter values
      this.batch = {
        batchThickness: parseFloat(this.panelThickness),
        complianceType: ToughenBatchComplianceTypes.standard,
        glassType: ToughenBatchGlassTypes.standard,
        lumenTransType: ToughenBatchLumenTransTypes.clearFloat,
        batchV1: '',
        batchV2: '',
        batchV3: '',
        batchV4: '',
        batchV5: '',
        batchV6: '',
        batchV7: '',
        batchV8: '',
        batchParticleCount: '',
        markingType: 'label',
        sizeTolerance: false,
        squareness: false,
        flatness: false,
        isPhotographTaken: false,
        uploadFileList: []
      }

      this.$nextTick(() => {
        this.$refs.inputBatchV1.select()
      })

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true
      this.form = this.clearFormResponse()

      var createBatchData = _.pick(this.batch, [
        'batchThickness', 'complianceType', 'batchV1', 'batchV2', 'batchV3', 'batchV4', 'batchParticleCount', 'markingType',
        'sizeTolerance', 'squareness', 'flatness', 'isPhotographTaken', 'uploadFileList'
      ])
      if(this.isComplianceAutomotive)
        createBatchData.lumenTransType = this.batch.lumenTransType
      if(!this.isComplianceAutomotive)
        createBatchData.glassType = this.batch.glassType
      if(this.isGlassTypePattern) {
        createBatchData.batchV5 = this.batch.batchV5
        createBatchData.batchV6 = this.batch.batchV6
        createBatchData.batchV7 = this.batch.batchV7
        createBatchData.batchV8 = this.batch.batchV8
      }

      this.$apiService.glassProductionStationService.createTougheningBatch(this.productionStationId, createBatchData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>